export function fixDiscountSum(
    sum: number | string = 0,
    fraction?: number | undefined
): number {
    if (!sum) return 0;

    if (typeof sum === 'string') sum = parseFloat(sum);

    if (isNaN(sum)) return 0;

    return parseFloat(sum.toFixed(fraction || 2));
}
